import React from 'react';
import { motion } from 'framer-motion';
import { Users, Star, FileText, Award, CheckCircle2 } from 'lucide-react';
export function StatsBar() {
  const stats = [{
    icon: <Users size={28} data-id="element-163" />,
    value: '+800',
    label: 'Profesionales confían en el sistema'
  }, {
    icon: <Star size={28} data-id="element-164" />,
    value: '4.9/5',
    label: 'Valoración promedio'
  }, {
    icon: <FileText size={28} data-id="element-165" />,
    value: '+180',
    label: 'Recursos clínicos y protocolos'
  }, {
    icon: <Award size={28} data-id="element-166" />,
    value: '#1',
    label: 'Sistema elegido en Argentina'
  }];
  const environments = ['Consultorio Privado', 'Hospitales Pediátricos', 'Centros de Salud', 'Clínicas de Rehabilitación Infantil', 'Atención Domiciliaria', 'Obras Sociales y Prepagas'];
  return <section className="bg-emerald-900 text-white relative" data-id="element-167">
      {/* Premium Divider */}
      <div className="absolute top-0 left-0 w-full h-[2px] bg-gradient-to-r from-transparent via-yellow-400/70 to-transparent" data-id="element-168"></div>

      <div className="py-14 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-169">
        {/* Stars + Rating */}
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex items-center justify-center gap-2 mb-4" data-id="element-170">
          <div className="flex text-yellow-400" data-id="element-171">
            {[...Array(5)].map((_, i) => <Star key={i} fill="currentColor" size={22} data-id="element-172" />)}
          </div>
          <span className="font-bold text-yellow-400 text-lg" data-id="element-173">4.9/5</span>
        </motion.div>

        {/* Main Heading */}
        <motion.h2 initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.05
      }} className="text-3xl md:text-4xl font-extrabold text-white text-center leading-tight mb-3" data-id="element-174">
          Elegido por más de 800 Pediatras en Argentina
        </motion.h2>

        {/* Subtitle */}
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-emerald-200 text-center text-base mb-10 max-w-xl mx-auto" data-id="element-175">
          El sistema de documentación clínica pediátrica más completo y
          profesional del mercado
        </motion.p>

        {/* 2x2 Stat Cards */}
        <div className="grid grid-cols-2 gap-4 mb-12 max-w-2xl mx-auto" data-id="element-176">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.08,
          duration: 0.4
        }} className="bg-emerald-800/60 border border-emerald-700/50 rounded-2xl p-5 flex flex-col items-center text-center" data-id="element-177">
              <div className="text-yellow-400 mb-3" data-id="element-178">{stat.icon}</div>
              <div className="text-3xl md:text-4xl font-extrabold text-white mb-1" data-id="element-179">
                {stat.value}
              </div>
              <div className="text-emerald-200 text-sm font-medium leading-tight" data-id="element-180">
                {stat.label}
              </div>
            </motion.div>)}
        </div>

        {/* Environments */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="text-center" data-id="element-181">
          <p className="text-xs font-bold tracking-widest text-emerald-400 uppercase mb-4" data-id="element-182">
            Utilizado en todo tipo de entornos pediátricos
          </p>
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2" data-id="element-183">
            {environments.map((env, index) => <div key={index} className="flex items-center gap-2" data-id="element-184">
                <CheckCircle2 className="w-4 h-4 text-yellow-400" data-id="element-185" />
                <span className="text-emerald-100 font-medium text-sm" data-id="element-186">
                  {env}
                </span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}